import styled from 'styled-components';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

const DefaultBox = styled.div`
    display:flex;
    max-width: 330px;
    width: 100%;
    justify-content: space-between;
    
    & .game-title {
        font-size: 12px;
        text-align: center;
    }
`;

const PcBox = DefaultBox;

const MobileBox = styled(DefaultBox)`
    & span.game-title {
        display: block;
    }
`;

export const GameViewDefaultBox = styledByDevice(PcBox, MobileBox);